export default __webpack_public_path__ + "static/media/pipelines-warmUp.40b47d14.svg";